import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'
import { api } from '../../api'

type Dose = {
  cod_cultura: number
  dose: number
  cod_tipo_medida: number
}

interface PropsAditivos {
  doses: Dose[]
  tipo_aditivo: number
  cod_fabricante: number
  cod_categoria_produto: number
  nome: string
  observacao: string
  descricao: string
  tipo_formulacao: number
  refetch: () => void
}

export const usePostAditivos = (): {
  carregando_salvar_aditivos: boolean
  mutate_aditivos: (params: PropsAditivos) => void
  isSuccess_aditivos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsAditivos> = useMutation(
    async (params: PropsAditivos) => {
      const {
        nome,
        tipo_formulacao,  
        cod_fabricante,
        tipo_aditivo,
        cod_categoria_produto,
        descricao,
        doses,
        observacao,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`/recomendacao/aditivo?codConta=${localConfig()?.conta}&embed=aditivo`, {
          nome,
          tipo_formulacao,
          tipo_aditivo,
          cod_fabricante,
          cod_categoria_produto,
          descricao,
          doses,
          observacao,
        })
        .then((response: any) => {
          successAlert('Aditivo cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar aditivo!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar aditivo!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_aditivos: mutation.isLoading,
    mutate_aditivos: mutation.mutate,
    isSuccess_aditivos: mutation.isSuccess,
  }
}

export const usePutAditivos = (
  cod: number
): {
  carregando_editar_aditivos: boolean
  mutate_editar_aditivos: (params: PropsAditivos) => void
  isSuccess_editar_aditivos: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsAditivos> = useMutation(
    async (params: PropsAditivos) => {
      const {
        nome,
        tipo_formulacao,
        tipo_aditivo,
        cod_fabricante,
        descricao,
        cod_categoria_produto,
        doses,
        observacao,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`/recomendacao/aditivo/${cod}?codConta=${localConfig()?.conta}`, {
          nome,
          tipo_formulacao,
          tipo_aditivo,
          cod_fabricante,
          cod_categoria_produto,
          descricao,
          doses,
          observacao,
        })
        .then((response: any) => {
          successAlert('Aditivo cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar aditivo!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar aditivo!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_editar_aditivos: mutation.isLoading,
    mutate_editar_aditivos: mutation.mutate,
    isSuccess_editar_aditivos: mutation.isSuccess,
  }
}
